/**
 * Converts a string to lowercase while preserving TypeScript type information.
 * @template T - Type of the input string
 * @param input - String to be converted to lowercase
 * @returns Lowercase version of the input string with preserved type
 */
export function toLowercase<T extends string>(input: T): Lowercase<T> {
  // Workaround TS not doing this inference correctly
  return input.toLowerCase() as Lowercase<T>;
}
